// extracted by mini-css-extract-plugin
export default {"card":"NZ-z","carouselContainer":"OZ-z","carouselContent":"PZ-z"};